import { Attributes } from '@leverege/ui-attributes';
const notEqual = (val1, val2) => val1 !== val2;
const conditions = {
  '<': (val1, val2) => val1 < val2,
  '>': (val1, val2) => val1 > val2,
  '=': (val1, val2) => val1 === val2,
  '!=': notEqual,
  '<>': notEqual
};
export function compare(val1, val2, condition) {
  const comparator = conditions[condition];
  if (!comparator) {
    throw Error('Attempting to compare values using non-existent comparator');
  }
  return comparator(val1, val2);
}
export function testConditions(condArr = [], item = null) {
  let conditions;
  if (typeof condArr[0] === 'string') {
    conditions = condArr[1];
    return combineResults(conditions, item, condArr[0]);
  }
  conditions = condArr;
  return combineResults(conditions, item);
}
function combineResults(conditions, item, operator = 'and') {
  let result = null;
  if (typeof conditions[0] === 'string') {
    return testConditions(conditions, item);
  }
  for (let i = 0; i < conditions.length; i++) {
    const {
      attribute,
      condition,
      value,
      message,
      checkNull,
      disable
    } = conditions[i];
    const val = Attributes.get(...attribute, item.ref == null ? item : item.data);
    if (val || checkNull) {
      const meets = compare(val, value, condition);
      if (meets) {
        if (result == null) {
          result = {
            messages: []
          };
        }
        result.disable = result.disable || disable;
        result.messages.push(message);
      }
    }
  }
  if (operator === 'and') {
    if (result?.messages?.length === conditions.length) {
      return result;
    }
    return null;
  }
  return result;
}